import { get } from './get';
import { list } from './list';

export const workflowSteps = {
  get,
  list,
};
